import { ArrowUpRight, Calendar } from "lucide-react";
import { Reveal } from "@/lib/motion";
import { BLOG } from "@/data/urban";

export const Blog = () => {
  return (
    <section id="blog" className="relative py-24 md:py-36 bg-surface">
      <div className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-10">
        <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-6">
          <div className="max-w-2xl">
            <Reveal><div className="overline text-ink">Journal</div></Reveal>
            <Reveal delay={0.05}>
              <h2 className="mt-4 font-heading text-3xl sm:text-4xl lg:text-5xl font-extrabold text-ink leading-[1.05]">
                Ideas, guides &amp; design inspiration.
              </h2>
            </Reveal>
          </div>
        </div>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-6">
          {BLOG.map((p, i) => (
            <Reveal key={p.title} delay={i * 0.08}>
              <article className="group h-full rounded-3xl overflow-hidden border border-hairline bg-canvas hover:-translate-y-1 transition-transform duration-300">
                <div className="aspect-[16/10] overflow-hidden">
                  <img src={p.img} alt={p.title} loading="lazy" className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-110" />
                </div>
                <div className="p-6">
                  <div className="flex items-center gap-3 text-xs text-ink-soft">
                    <span className="bg-canvas text-ink-soft font-semibold px-2.5 py-1 rounded-full">{p.category}</span>
                    <span className="flex items-center gap-1"><Calendar className="h-3.5 w-3.5" /> {p.date}</span>
                  </div>
                  <h3 className="mt-4 font-heading text-lg font-bold text-ink leading-snug group-hover:text-ink transition-colors">{p.title}</h3>
                  <p className="mt-2 text-sm text-ink-soft leading-relaxed">{p.excerpt}</p>
                  <span className="mt-5 inline-flex items-center gap-1 text-sm font-semibold text-ink group-hover:text-ink transition-colors">Read article <ArrowUpRight className="h-4 w-4" /></span>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
